export const FETCH_CLIENT_KEGS_FOR_DB = 'FETCH_CLIENT_KEGS_FOR_DB';
export const FETCH_COMPANY_STATS_FOR_DB = 'FETCH_COMPANY_STATS_FOR_DB';
export const FETCH_BRAND_STATS = 'FETCH_BRAND_STATS';
export const FETCH_LOCATION_STATS = 'FETCH_LOCATION_STATS';
export const FETCH_CLIENTS_STATS = 'FETCH_CLIENTS_STATS';
export const FETCH_STOCK_TYPE_STATS = 'FETCH_STOCK_TYPE_STATS';
